export default __webpack_public_path__ + "static/media/bixin.bc63bf6e.svga";